export const EXCLUDE_OPTION_VALUE = -1;

export const excludeOption = {
  label: 'Exclude from Asset Bucketing',
  value: EXCLUDE_OPTION_VALUE,
};
